import React, { useState } from "react";
import { HiSignal } from "react-icons/hi2";
import { CiSearch } from "react-icons/ci";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { BsGear, BsPerson } from "react-icons/bs";
import { HiBuildingOffice2 } from "react-icons/hi2";
const Signals = () => {
  const [onClick, setOnCLick] = useState(false);
  const [onSearching, setSearching] = useState(false);
  const [toggleAll, setToggleAll] = useState('')
  const [togglePeople, setTogglePeople] = useState('')
  const [toggleCompanies, setToggleCompanies] = useState('')
  const onClickHandler = (e) => {
    setOnCLick(!onClick);
  };
  const toggleHandle = () => {
    setToggleAll("");
    setTogglePeople("")
     
  };
  return (
    <div
      className={`${
        onClick ? "flex flex-col border-blue-700 border mr-1 h-[30rem]" : ""
      }`}
    >
      <button
        onClick={onClickHandler}
        className="flex flex-row justify-between w-full hover:bg-gray-100"
      >
        <div className="flex w-full items-center justify-between px-2 h-12 hover:text-blue-600 font-medium">
          <div className="flex items-center">
            <HiSignal />
            <div className="ml-2 text-sm">Signals</div>
          </div>
          <div className="flex items-center">
            <div className="text-white text-sm h-6 rounded mr-3 w-[3rem] bg-green-400">
              New!
            </div>
            {!onClick ? (
              <FaCaretDown className="text-gray-500 mr-2" />
            ) : (
              <FaCaretUp className="text-gray-500 mr-2" />
            )}
          </div>
        </div>
      </button>
      {onClick && (
        <>
          <button className="flex text-blue-600 items-center mt-4 ml-4 justify-start">
            <BsGear className="text-xs  mr-1" />
            <p className="text-xs font-semibold">Manage signals</p>
          </button>
          <div className="flex flex-col items-center m-4 rounded h-full border border-gray-300">
            <div className="flex items-center w-full h-8 border-b cursor-pointer">
              <CiSearch className="text-gray-500 mx-2" />
              <input
                type="text"
                placeholder="Search for signal"
                className="text-gray-500 text-sm font-semibold outline-none"
              />
            </div>
            <div className="flex items-center text-sm font-semibold justify-between border-b h-10 w-full">
              <div className="flex justify-center w-full h-full text-center border-b hover:border-blue-600">
                <button>All</button>
              </div>
              <div className="flex justify-center w-full h-full text-center border-b hover:border-blue-600">
                <button>People</button>
              </div>
              <div className="flex justify-center w-full h-full text-center border-b hover:border-blue-600">
                <button>Companies</button>
              </div>
            </div>
            <div className="w-full">
              <div className="flex justify-between hover:bg-gray-100 w-full items-center h-10">
                <div className="flex items-center px-3 text-sm justify-center">
                  <input
                    id="default-checkbox"
                    type="checkbox"
                    value=""
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    for="default-checkbox"
                    class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    High buying intent
                  </label>
                </div>
                <div className="flex items-center mr-6 rounded-sm h-6 w-6 bg-gray-100 justify-center">
                  <BsPerson className="text-blue-400" />
                </div>
              </div>

              <div className="flex justify-between hover:bg-gray-100 w-full items-center h-10">
                <div className="flex items-center px-3 text-sm justify-center">
                  <input
                    id="default-checkbox"
                    type="checkbox"
                    value=""
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    for="default-checkbox"
                    class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Rapid growth
                  </label>
                </div>
                <div className="flex items-center mr-6 rounded-sm h-6 w-6 bg-gray-100 justify-center">
                  <HiBuildingOffice2 className="text-green-400" />
                </div>
              </div>

              <div className="flex justify-between hover:bg-gray-100 w-full items-center h-10">
                <div className="flex items-center px-3 text-sm justify-center">
                  <input
                    id="default-checkbox"
                    type="checkbox"
                    value=""
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    for="default-checkbox"
                    class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Opened 2+ emails in past week
                  </label>
                </div>
                <div className="flex items-center mr-6 rounded-sm h-6 w-6 bg-gray-100 justify-center">
                  <BsPerson className="text-blue-400" />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Signals;
